import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GetWishlistRequest } from './getwishlistrequest';

export class GetWishlistAPI extends SixdeeCRBTAPI<GetWishlistRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/view-wishlist
        return "view-wishlist";
    }

    getRequestData()
    {
        return "identifier="+ this.getRequest().getGetWishlistRequest().getIdentifier()+"&"+
               "msisdn="+ this.getRequest().getGetWishlistRequest().getMsisdn()+"&"+
               "language="+ this.getRequest().getGetWishlistRequest().getLanguage()+"&"+
               "wishlistType="+ this.getRequest().getGetWishlistRequest().getWishlistType();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/getwishlist/getwishlistapi.tsx